import React from 'react';

const VastuLensLogo = ({ height = 40, color = 'var(--color-primary)' }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', fontFamily: 'Playfair Display, serif' }}>
      <img
        src="/logo.jpg"
        alt="VastuLens Logo"
        style={{
          height: `${height}px`,
          width: 'auto',
          marginRight: '12px',
        }}
      />
      <span style={{ fontSize: `${height * 0.6}px`, color: color, fontWeight: '700', lineHeight: 1 }}>
        VastuLens
      </span>
    </div>
  );
};

export default VastuLensLogo;

